export default function (Component) {
Component.options.__docs = "<p><code>FdCalendar</code> supports <code>v-model</code>. The example below shows two calendars bound to the same model.</p>\n"
}